// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7FJBr","containerOne":"Contact_containerOne__CCXRH","containerTwo":"Contact_containerTwo__WH+Pw","contactContainer":"Contact_contactContainer__JfJc1"};